/** @type {readonly ['imagem', 'imagem_2', 'imagem_3', 'imagem_4']} */
export const PRODUCT_IMAGE_KEYS = ['imagem', 'imagem_2', 'imagem_3', 'imagem_4'];

/**
 * @typedef {{
 *   sectionPhotoFallback?: boolean,
 *   sectionImages?: Record<string, string>,
 * }} ProductImageContext
 */

/**
 * @param {unknown} p
 * @returns {string[]}
 */
export function productGalleryUrlsRaw(p) {
  if (!p || typeof p !== 'object') return [];
  /** @type {Record<string, unknown>} */
  const row = p;
  const out = [];
  for (const k of PRODUCT_IMAGE_KEYS) {
    const raw = row[k];
    if (raw == null) continue;
    const s = typeof raw === 'string' ? raw.trim() : '';
    if (s !== '') out.push(s);
  }
  return out;
}

/**
 * @param {unknown} p
 */
export function productSectionName(p) {
  if (!p || typeof p !== 'object') return 'Geral';
  /** @type {Record<string, unknown>} */
  const row = p;
  const sec = String(row.secao || 'Geral').trim();
  return sec || 'Geral';
}

/**
 * @param {unknown} p
 * @param {Record<string, string> | undefined} sectionImages
 */
export function sectionImageRawForProduct(p, sectionImages) {
  if (!sectionImages) return '';
  const sec = productSectionName(p);
  const img = sectionImages[sec];
  return typeof img === 'string' && img.trim() !== '' ? img.trim() : '';
}

/**
 * URLs de imagem do produto; se vazio e fallback activo, usa foto da secção.
 * @param {unknown} p
 * @param {ProductImageContext | undefined} ctx
 * @returns {string[]}
 */
export function productGalleryUrls(p, ctx) {
  const own = productGalleryUrlsRaw(p);
  if (own.length > 0) return own;
  if (!ctx?.sectionPhotoFallback) return [];
  const fallback = sectionImageRawForProduct(p, ctx.sectionImages);
  return fallback ? [fallback] : [];
}

/**
 * Primeira imagem para exibir (com fallback de secção se configurado).
 * @param {unknown} p
 * @param {ProductImageContext | undefined} ctx
 * @returns {string}
 */
export function firstDisplayImageRaw(p, ctx) {
  const urls = productGalleryUrls(p, ctx);
  return urls[0] ?? '';
}

/**
 * Só imagens do produto (sem fallback).
 * @param {unknown} p
 * @returns {string}
 */
export function firstProductImageRaw(p) {
  const urls = productGalleryUrlsRaw(p);
  return urls[0] ?? '';
}
